import lookup from "country-code-lookup";
import ArrowUpTrayIcon from "@heroicons/react/24/solid/ArrowUpTrayIcon";
import BuildingStorefrontIcon from "@heroicons/react/24/solid/BuildingStorefrontIcon";
import ChartBarIcon from "@heroicons/react/24/solid/ChartBarIcon";
import Cog6ToothIcon from "@heroicons/react/24/solid/Cog6ToothIcon";
import ComputerDesktopIcon from "@heroicons/react/24/solid/ComputerDesktopIcon";
import HomeIcon from "@heroicons/react/24/solid/HomeIcon";
import PresentationChartLineIcon from "@heroicons/react/24/solid/PresentationChartLineIcon";
import UserCircleIcon from "@heroicons/react/24/solid/UserCircleIcon";
import UserIcon from "@heroicons/react/24/solid/UserIcon";
import { MenuItemType } from "~/components/dashboard/Sidebar/MenuItem";
import { ActivateIcon } from "~/components/dashboard/Verify/ActivateIcon";
import KeyIcon from "@heroicons/react/24/outline/KeyIcon";
import PresentationChartBarIcon from "@heroicons/react/24/solid/PresentationChartBarIcon";

export const DEFAULT_RADIUS = 0.6;
export const DEFAULT_TRIAL_DAYS = 10;
export const CONTACT_EMAIL = "benh@konnect-app.io";
export const LOGIN_URL = "/login";
export const LOGOUT_URL = "/logout";
export const SUBSCRIBE_URL = "/subscription";
export const PROFILE_URL = "/app/profile";
export const APP_PAGE_URL = "/app/sales";
export const DATABASE_UPLOAD_URL = "/app/upload-data";

// Flip to `true` to put the app into maintenance mode. While enabled,
// login/signup are blocked and authenticated routes redirect to /maintenance.
// API/webhook routes (Stripe, Inngest, OAuth callbacks) are intentionally
// unaffected so background jobs keep working.
export const MAINTENANCE_MODE = false;
export const MAINTENANCE_URL = "/maintenance";
export const MAINTENANCE_MESSAGE =
  "We're solving a technical issue at the app level. Please try again shortly.";
export const PRO_APP_MESSAGE_LIMIT = 5000;
export const STARTER_APP_MESSAGE_LIMIT = 100;
export const INTRO_APP_MESSAGE_LIMIT = 50;

export const ENHANCEMENT_PRICE_PER_RECORD = 0.5;

// VaultRE Integration
export const VAULTRE_PROCESSING_PERIOD_HOURS = 48;
export const VAULTRE_NOTE_PREFIX = "[Konnect]";

// TODO: when adding  country here, also do it here
// stripe.server.ts#26 & #67
export const COUNTRIES = lookup.countries.filter(
  (country) =>
    country.iso2 === "NZ" ||
    country.iso2 === "AU" ||
    country.iso2 === "GB" ||
    country.iso2 === "CA" ||
    country.iso2 === "US"
);
export const DEFAULT_COUNTRY_ISO = "NZ";

export const NUMBER_SALES_PER_PAGE = 10;
export const SALES_OLD_DAYS = 90;
export const LISTED_OLD_DAYS = 90;

export const CONTACT_FREQUENCIES = [
  { value: 30, name: "1 month" },
  { value: 60, name: "2 months" },
  { value: 90, name: "3 months" },
];

export const DEFAULT_CONTACT_FREQUENCY = CONTACT_FREQUENCIES[0];
export const DEFAULT_IMPORT_NEW_ADDRESS_CREATES_PROPERTY = true;
export const SUPABASE_IMPORT_BUCKET = "import";

export const MENU_ITEMS: MenuItemType[] = [
  {
    id: 1,
    title: "Local sales",
    link: APP_PAGE_URL,
    icon: <HomeIcon />,
  },
  {
    id: 2,
    title: "Just listed",
    link: "/app/listed",
    icon: <BuildingStorefrontIcon />,
  },
  {
    id: 3,
    title: "Database",
    link: "/app/homeowners",
    icon: <UserIcon />,
  },
  {
    id: 4,
    title: "Digital leads",
    link: "/app/homeowners?type=digital",
    icon: <ComputerDesktopIcon />,
  },
  {
    id: 5,
    title: "Market Intel",
    link: "/app/intelligence",
    icon: <PresentationChartBarIcon />,
  },
];

export const ANALYTICS_MENU_ITEM: MenuItemType = {
  id: 6,
  title: "Analytics",
  link: "/app/analytics",
  icon: <ChartBarIcon />,
};

export const INSIGHTS_MENU_ITEM: MenuItemType = {
  id: 7,
  title: "Insights",
  link: "/app/insights",
  icon: <PresentationChartLineIcon />,
};

export const VERIFY_MENU_ITEM: MenuItemType = {
  id: 8,
  title: "Activate",
  link: "/app/activate",
  icon: <ActivateIcon />,
};

export const ACCOUNT_MENU_ITEMS: MenuItemType[] = [
  {
    id: 1,
    title: "Profile",
    link: "/app/profile",
    icon: <UserCircleIcon />,
  },
  {
    id: 2,
    title: "Upload data",
    link: "/app/upload-data",
    icon: <ArrowUpTrayIcon />,
  },
  {
    id: 3,
    title: "Password",
    link: "/app/profile/password",
    icon: <KeyIcon />,
  },
  {
    id: 4,
    title: "Settings",
    link: "/app/profile/settings",
    icon: <Cog6ToothIcon />,
  },
];
